<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-card-title>Worker Attendence</v-card-title>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="sabod"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="sabod"
                        label="Search Attendence Based on Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="sabod"
                      no-title
                      scrollable
                      :max="new Date().toISOString().substr(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(sabod)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-btn
                    class="mr-4 mt-3 pt-0"
                    color="primary"
                    @click="btnsearch"
                    >Search</v-btn
                  >
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-data-table
                    :headers="headers"
                    :items="tags"
                    sort-by="id"
                    class="elevation-1"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    :search="search"
                  >
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-toolbar-title>Attendences</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                       v-model="editedItem.clockin"
                                        label="Clock In Time"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.clockout"
                                       label="Clock Out Time"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                      <v-text-field
                                        v-model="editedItem.overtime"
                                       label="Overtime"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close"
                                  >Cancel</v-btn
                                >
                                <v-btn color="blue darken-1" text @click="save"
                                  >Save</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                    </template>
                    <template v-slot:no-data>
                      <v-btn color="primary" @click="initialize">Reset</v-btn>
                    </template>
                    
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  name: 'hr_attendence',
  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    sabod: new Date().toISOString().substr(0, 10),
    menu: null,
    search: '',
    dialog: false,
    loading: true,
    tags: [],
    hide: true,
    editedIndex: -1,
    editedItem: {
      clockin: '',
      clockout: ''
    },
    defaultItem: {
       clockin: '',
      clockout: ''
    },
    headers: [
      { text: 'NAME', value: 'name' },
      { text: 'FIN NUMBER', value: 'fin' },
      { text: 'CLOCK IN', value: 'clockin' },
      { text: 'CLOCK OUT', value: 'clockout' },
      { text: 'LOCATION', value: 'location' },
      { text: 'OVERTIME', value: 'overtime' },
      { text: 'Hours', value: 'hours' },
      { text: 'Minutes', value: 'minutes' },
      { text: 'Actions', value: 'action', sortable: false }
    ]
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    btnsearch() {
      ApiService.get('/WorkerAttendence/' + this.sabod)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.tags = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    initialize() {
      ApiService.get('/WorkerAttendence/' + this.today)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.tags = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    editItem(item) {
      this.editedIndex = this.tags.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save(){
      let id = this.tags[this.editedIndex].id
      let clockin = this.editedItem.clockin
      let clockout = this.editedItem.clockout
      let overtime = this.editedItem.overtime
      let parent = this
      ApiService.post('/WorkerAttendence/' + id, {
          clockin,
          clockout,
          overtime
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.btnsearch()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
         this.close()
    }
  }
}
</script>
